import { useDialog } from "@shared/features/dialog/useDialog";
import {
  marketingContentData,
  marketingSendingInstitutionsData,
} from "../../marketing.data";
import { MarketingContent } from "./MarketingContent";
import { useHandleNavigationClick } from "@shared/features/mobileMenu/useHandleNavigationClick";

export function MarketingContentContainer({}) {
  const handleDonateClick = () => {
    window.open(
      "https://www.every.org/outlast-foundation/f/pollinator",
      "_blank"
    );
  };

  const { handleNavigationAnchorClick } = useHandleNavigationClick();

  const { openDialog } = useDialog();

  return (
    <MarketingContent
      sectionsContent={marketingContentData}
      sendingInstitutionItems={marketingSendingInstitutionsData}
      onAddYourInstitutions={() => openDialog("addYourInstitution")}
      onHireUsClick={() => openDialog("hireUs")}
      onNewsletterClick={() => openDialog("newsletter")}
      onDonateClick={handleDonateClick}
      onNavigationAnchorClick={handleNavigationAnchorClick}
    />
  );
}

export default MarketingContentContainer;
